/** Persisted theme preference: light or dark. */
export type ThemeMode = 'light' | 'dark';

/**
 * Returns the initial theme mode when no persisted value exists.
 * Seeds from the OS color-scheme preference once at store creation.
 */
export function getInitialThemeMode(): ThemeMode {
  try {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}
